<script setup>
import { Dropdown } from 'bootstrap';


</script>
<template>
    <!-- Navbar -->
    <nav class="app-header navbar navbar-expand bg-body navbar-white navbar-light">
        <div class="container-fluid">
            <!-- Start navbar links -->
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a class="nav-link" data-lte-toggle="sidebar" href="#" role="button">
                        <i class="fas fa-bars"></i>
                    </a>
                </li>
                <!--            <li class="nav-item d-none d-md-block">-->
                <!--                <a href="#" class="nav-link">Home</a>-->
                <!--            </li>-->
                <!--            <li class="nav-item d-none d-md-block">-->
                <!--                <a href="#" class="nav-link">Contact</a>-->
                <!--            </li>-->
            </ul>
            <!-- Left navbar links -->
            <!--        <ul class="navbar-nav">-->
            <!--            <li class="nav-item">-->
            <!--                <a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>-->
            <!--            </li>-->
            <!--        </ul>-->
            <!-- Right navbar links -->
            <ul class="navbar-nav ml-auto">
                <li class="nav-item">
                    <div class="dropdown">
                        <button
                            class="btn btn-link p-0"
                            type="button"
                            id="dropdownMenuButton"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            <img src="/images/img.png" class="img-thumbnail img-circle" alt="..." style="width: 33px;">
                        </button>
                        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
                            <li>
                                <a class="dropdown-item" href="/"><i class="fa-duotone fa-solid fa-circle-right"></i> Thoát</a>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>

    </nav>
</template>

<style scoped>
.dropdown-menu-end {
    right: 0;
    left: auto;
}
</style>
